import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { CopyOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobalNotification } from '../../../utils/notificationProvider'
import { useMutation } from 'react-query'
import { copyContractComparison } from '../../../services/contractComparison'
import { updateIsCopyContractComparison } from '../../../reducer/contractComparison/contractComparisonSlice'

const CopyContractComparison = ({
  contractTypeSelected,
  alignmentTemplateValue,
  contractComparisonFilters,
  selectedAlignmentValues,
  tableGridData
}) => {
  //   const columns = useSelector((state) => state.contractComparison.columns);
  //   const dataSource = useSelector((state) => state.contractComparison.dataSource);

  const {
    isLoading: copyContractComparisonLoading,
    data: copyContractComparisonData,
    mutate: mutateCopyContractComparison
  } = useMutation(copyContractComparison)

  const pushNotification = useGlobalNotification()
  const dispatch = useDispatch()
  const interimScenarioId = useSelector((state) => state.Common.interim_scenario_id)
  const selectedWacId = useSelector((state) => state.ContractComparison.selectedWacId)
  const scenario_id = useSelector((state) => state.Common.scenario_id)

  const handleCopySuccess = () => {
    pushNotification(
      'success',
      'Data copied successfully!',
      'Contract Comparison data copied successfully.',
      3
    )
  }

  const handleCopyError = () => {
    pushNotification('error', 'Copy failed!', 'Error copying the data.', 3)
  }

  const generateContractComparisonTableHeaders = (columns) => {
    let parentHeaders = []
    let childHeaders = []

    columns.forEach((col) => {
      if (col.children) {
        col.children.forEach((child) => {
          parentHeaders.push(col.title)
          childHeaders.push(child.title)
        })
      } else {
        parentHeaders.push(col.title)
        childHeaders.push('')
      }
    })

    return {
      parentHeaders: parentHeaders.join('\t'),
      childHeaders: childHeaders.join('\t')
    }
  }

  useEffect(() => {
    dispatch(updateIsCopyContractComparison(copyContractComparisonLoading))
  }, [copyContractComparisonLoading])

  const onCopyContractComparison = () => {
    mutateCopyContractComparison(
      {
        model: {
          filters: [],
          list_details: [],
          settings: {
            interim_scenario_id: interimScenarioId,
            scenario_id: scenario_id,
            contract_type: contractTypeSelected,
            alignment_template_id: alignmentTemplateValue,
            wac_type_selected_id: selectedWacId,
            alignment_numbers: selectedAlignmentValues.map((val) => val.value),
            account_or_corporate_ids: contractComparisonFilters
          }
        },
        user_id: sessionStorage.getItem('user_id'),
        application_role: sessionStorage.getItem('application_role')
      },
      {
        onSuccess: (data) => {
          const dataToCopy = data?.data?.result?.data
          navigator.clipboard
            .writeText(dataToCopy)
            .then(() => {
              console.log('Data copied to clipboard successfully!')
              handleCopySuccess()
            })
            .catch((error) => {
              console.error('Error copying data to clipboard:', error)
              handleCopyError()
            })
        }
      }
    )
  }
  return (
    <div className="copy-contract-comparison-button">
      <Button
        onClick={onCopyContractComparison}
        className="button-icon-align"
        disabled={Object.keys(tableGridData).length == 0}
      >
        <CopyOutlined />
      </Button>
    </div>
  )
}

export default CopyContractComparison
